

function Button({ fetcher, display_text }) {
    return (
        <button className="cta-button" onClick={fetcher}>{display_text}</button>
    );
  }

  export default Button;